import * as notificationInterfaces from '../interfaces';
import * as ui_actionCreators from '../../../redux/ui/actions';
import { makeNotificationsList } from '../../../Containers/Notifications/notificationSelectors';
import { selectActiveNotificationId } from '../../../redux/ui/uiSelectors';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import NotificationListItem from './NotificationListItem';
import React from 'react';
import SimpleCollection from '../../Organisms/SimpleCollection/';
import * as authRoutines from '../../../Containers/Auth/authRoutines';
const NotificationsList = (props: notificationInterfaces.INotificationsProps) => {
    const { history, match } = props;
    const dispatch = useDispatch();
    const notifications = useSelector(makeNotificationsList);
    const activeNotificationId = useSelector(selectActiveNotificationId);

    if (notifications.length && !activeNotificationId) {
        //Handles the case when we first land on the notifications page, and there are is at least one notification
        dispatch(ui_actionCreators.setActiveNotification(notifications[0]['id']));
    }
    const handleCreate = () => {
        dispatch(authRoutines.checkForReauth())
        history.push(`${match.url}/new`);
    };
    const handleClick = (event: any, notification_id: string) => {
        event.preventDefault();
        dispatch(ui_actionCreators.setActiveNotification(notification_id));
    };

    return (
        <React.Fragment>
            <Grid item md={4} style={{ marginTop: '20px' }} xs={12}>
                <SimpleCollection
                    data={notifications}
                    fabPosition="absolute"
                    fabRight={'0'}
                    height="60vh"
                    itemRender={(notification, idx) => {
                        return (
                            <NotificationListItem
                                data={notification}
                                key={`item-${idx}`}
                                onClick={handleClick}
                                selected={notification.id === activeNotificationId}
                            />
                        );
                    }}
                    mode="dark"
                    onCreate={handleCreate}
                    reorderable={false}
                    type="list"
                />
            </Grid>
        </React.Fragment>
    );
};

export default withRouter(NotificationsList);
